import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { APP_LIST, GlobalStyles, PERMISSIONS, LAYOUT } from '@shared/constants';
import {
  AppSwitcher,
  BarLayout,
  PrivateRoute,
  TokenComponent,
  SidebarHeaderLayout,
  ProfileMenu,
} from '@shared/components';
import { isAuthorized } from '@utils';
import { AppContextConsumer } from '@shared/contexts';
import { SharedService } from '@consumers/services';
import BrandLogo from '@assets/icons/brand-logo.svg';
import ReassignerModule from './reassigner';
import useStyles from './style';

export default () => {
  const classes = useStyles();

  GlobalStyles();
  return (
    <Router>
      <Switch>
        <Route path='/token' component={TokenComponent} />
        <AppContextConsumer>
          {({
            headerElements,
            selectedThemeVariant,
            setSelectedThemeVariant,
            setSelectedLayout,
            currentWorkspace,
            appRatingData,
            setAppRatingData,
            selectedLayout,
          }) => {
            const Layout =
              selectedLayout === LAYOUT.SIDEBAR_HEADER
                ? SidebarHeaderLayout
                : BarLayout;

            return (
              <Layout
                hideSideBar
                headerContent={
                  <>
                    <img
                      alt='Brand logo'
                      src={BrandLogo}
                      width={137}
                      className='ml-7 c-pointer'
                      onClick={() => window.location.reload()}
                    />
                    <div className='flex-1'>{headerElements}</div>
                    <div className='d-flex f-align-center'>
                      <AppSwitcher
                        className='mr-5'
                        currentApp={APP_LIST.BOILERPLATE}
                        disabled={true}
                      />
                      <ProfileMenu
                        getVersion={SharedService.getVersion}
                        hasSettings={isAuthorized(PERMISSIONS.MANAGE_SETTINGS)}
                        currentWorkspace={currentWorkspace}
                        handleRatingOpen={() =>
                          setAppRatingData({ isOpen: true })
                        }
                        onUserDataFetched={user => {
                          setAppRatingData({
                            isOpen: user?.show_rating_popup_on_request,
                            showOnPackageSubmit:
                              user?.show_rating_popup_on_package_submit,
                          });
                        }}
                      />
                    </div>
                  </>
                }
                classes={{
                  listItemText: classes.listItemText,
                  appBar: classes.appBar,
                }}
              >
                <ToastContainer
                  className={classes.toastContainer}
                  bodyClassName='align-center'
                  hideProgressBar
                />
                <Switch>
                  <PrivateRoute
                    path='/reassigner'
                    component={ReassignerModule}
                  />
                  <Redirect from='/' exact to='/reassigner' />
                  <Route
                    render={props => (
                      <>
                        <div className='m-10 pt-10 d-flex f-justify-center f-align-center flex-1'>
                          <div>
                            <h2>Uh Oh! Something is not right...</h2>
                            <h4>
                              The page you are trying to access does not exist.
                            </h4>
                            <h4>
                              Maybe you want to go to{' '}
                              <span
                                className='color-primary c-pointer'
                                onClick={() => {
                                  props.history.push('/');
                                }}
                              >
                                Home
                              </span>{' '}
                              page?
                            </h4>
                          </div>
                        </div>
                      </>
                    )}
                  />
                </Switch>
              </Layout>
            );
          }}
        </AppContextConsumer>
      </Switch>
    </Router>
  );
};
